<script setup lang="ts">
import SidebarMenu from '@/components/SidebarMenu.vue'
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { threadsUrls } from '@/util/links'
import { storeToRefs } from 'pinia'
import { useVisibilityStore } from '@/visibility/visibility.store'
import { getAnalyticsTracker } from '@/tracking/analytics/plugin.ts'
import { EVENT_NAMES } from '@/tracking/analytics/event_names.ts'

const route = useRoute()
const isItemSelected = (pathToCheck: string) => {
  return computed(() => route.path === pathToCheck).value
}

const { threadsVisibility } = storeToRefs(useVisibilityStore())
const analytics = getAnalyticsTracker()

const libraryAllFolders = '/library/all'
const libraryMyFolders = '/library/owned'
const librarySharedFolders = '/library/shared'
const recentGoals = '/library/recently_viewed/goals'
const recentStrategies = '/library/recently_viewed/strategies'
const recentResources = '/library/recently_viewed/resources'
const libraryArchivedFolders = '/library/archived'
const recentlySaved = '/library/recently_saved'

const lists = computed(() => [
  {
    heading: 'LIBRARY',
    items: [
      {
        label: 'All Folders',
        route: libraryAllFolders,
        selected: isItemSelected(libraryAllFolders),
        isPremiumRoute: true,
        submenu: [
            {
              label: 'My Folders',
              route: libraryMyFolders,
              selected: isItemSelected(libraryMyFolders)
            },
            {
              label: 'Shared with Me',
              route: librarySharedFolders,
              selected: isItemSelected(librarySharedFolders)
            }
          ]
      },
      {
        label: 'Recently Saved',
        route: recentlySaved,
        selected: isItemSelected(recentlySaved),
        isPremiumRoute: true
      },
      {
        label: 'Archived',
        route: libraryArchivedFolders,
        selected: isItemSelected(libraryArchivedFolders),
        isPremiumRoute: true
      },
      ...(threadsVisibility.value ? [{
        label: 'Saved Threads',
        url: `${threadsUrls.saved}?ref=tk_library`,
        selected: false,
        target: '_blank',
        onClick: () => {
          analytics.sendEvent(EVENT_NAMES.LIBRARY.CLICKED_SAVED_THREADS)
        }
      }] : [])
    ]
  },
  {
    heading: 'RECENTLY VIEWED',
    items: [
      {
        label: 'Goals',
        route: recentGoals,
        selected: isItemSelected(recentGoals)
      },
      {
        label: 'Strategies',
        route: recentStrategies,
        selected: isItemSelected(recentStrategies)
      },
      {
        label: 'Resources',
        route: recentResources,
        selected: isItemSelected(recentResources)
      }
    ]
  }
])
</script>

<template>
  <SidebarMenu :lists="lists" title="YOUR CONTENT" />
</template>
